function setSelectedService(state = [], action) {
  if (action.type === 'SELECT_SERVICE') {
    return action.service
  }
  return state;
}

function clearSelectedService(state = [], action) {
  if (action.type === 'CLEAR_SERVICE') {
    return {}
  }
  return state;
}

function selectedService(state=[], action) {
  if (!!action.service) {
    if (Object.keys(action.service).length > 0) {
      return setSelectedService(state, action);
    }
    else {
      return clearSelectedService(state, action);
    }
  }
  return state;
}

export default selectedService;


// WEBPACK FOOTER //
// ./src/reducers/selectedService.js